// eslint-disable-next-line @tseslint/typedef
const FLOATING_HOST_BIND_CLASSES = {
  "[class.floating]": "true"
} as const;
// eslint-disable-next-line @tseslint/typedef
const FLOATING_HOST_BIND_ATTRIBUTES = {
  "[attr.tabindex]": "isHostOpen() ? 0 : -1",
  "[style.position]": "positionStyle()",
  "[style.display]": "display()",
  "[style.zIndex]": "zIndex()",
  "[style.visibility]": "visibility()",
  "[style.pointerEvents]": "pointerEvents()"
} as const;

export const FLOATING_HOST_BIND:
    typeof FLOATING_HOST_BIND_CLASSES & typeof FLOATING_HOST_BIND_ATTRIBUTES = {
      ...FLOATING_HOST_BIND_CLASSES,
      ...FLOATING_HOST_BIND_ATTRIBUTES
    };
